/* eslint-disable */

function mapTo0To100(value) {
  // Ensure the input value is within the range [-1, 1]
  value = Math.max(-1, Math.min(1, value));

  // Map the value to the range [0, 100]
  const mappedValue = (value + 1) * 50;

  return mappedValue;
}

export function createSizeInsights(conf) {
  // TODO -1 = runs bigger, +1 - runs smaller
  let settings = {
    visual: "scale", // scale|text
    size_shift: 0,

    // Translations
    texts: {
      size_down: "Runs bigger. Buy one size smaller than your regular size",
      size_half_down: "Runs slightly bigger. Buy half a size smaller than your regular size",
      size_regular: "True to size. Buy your regular size",
      size_half_up: "Runs slightly smaller. Buy half a size bigger than your regular size",
      size_up: "Runs smaller. Buy one size bigger than your regular sizes",
      // Scale text
      scale_small: "Smaller",
      scale_regular: "True to size",
      scale_large: "Bigger",
    },
    // Visual - Scale
    scale_edge_type: "line", // line|arrow
    scale_caret_type: "ball",
    scale_caret_offset_center: 7,
    scale_caret_offset_edge: 8,
    scale_breakpoints: false,
    scale_markers: false,

    // Visual - Text
    text_scale_breakdown: [
      { shift: -0.7, text: 'size_down' },
      { shift: -0.2, text: 'size_half_down' },
      { shift: 0.2, text: 'size_regular' },
      { shift: 0.7, text: 'size_half_up' },
      { shift: 1, text: 'size_up' },
    ],

    // All styling attributes
    style: {
      es_si_display: "block",
      es_si_width: "auto",
      es_si_padding: "10px 0",
      es_si_margin: "0",

      es_si_scale_background: "transparent",
      es_si_scale_bar: "gray",
      es_si_scale_edge: "gray",
      es_si_scale_font_color: "gray",
      es_si_scale_font_size: "14px",
      es_si_scale_line_height: "14px",
      es_si_scale_caret: "black",
      es_si_scale_marker_color: "black",

      es_si_txt_wrapper_background: "#e6e6e6",
      es_si_txt_align: "left",
      es_si_txt_padding: "5px 10px",
    },

    // Default placement type
    placeholder_type: "append", // append|prepend|before|after
  };

  settings = Object.assign(settings, conf);

  // If enabled, make the visual scale caret stick to one of the breakpoints
  if (settings.scale_breakpoints) {
    for (let i = 0; i < settings.scale_breakpoints.length ; i++) {
      if (settings.shift <= settings.scale_breakpoints[i].shift) {
        settings.shift = settings.scale_breakpoints[i].stick
        break
      }
    }
  }

  // Start generating visuals
  /*
  	Get shift in 0-100 value
    0 Item is smaller
    50 - Item is true to size
    100 - Item is bigger
  */
  let shift = mapTo0To100(settings.shift * -1); // Reverse shift, replace recommendation shift into item sizing shift
  let wrapper = document.createElement("div");
  wrapper.className = "size_insights " + settings.visual;

  if (settings.visual === "scale") {
    // Build scale size insights
    let html = {
      edge: '<div class="edge <type> <side>"> </div>',
      bar: '<div class="size_insights--bar"> </div>',
      caret: '<div style="left: calc(<position>% - <center_position>px)" class="size_insights--caret <type>"> </div>',
      marker: '<div style="left: calc(<position>%)" data-pos="<shift>" class="size_insights--marker <show> <size>"> </div>',
      content: '<div class="size_insights--content <side>"><text></div>',
    };

    // Offset caret position
    let caret_pos = settings.scale_caret_offset_edge / 2 + (shift / 100) * (100 - settings.scale_caret_offset_edge);

    // HTML generation
    wrapper.innerHTML = `
      ${html.edge
        .replace("<side>", "left")
        .replace("<type>", settings.scale_edge_type)}
      ${html.edge
        .replace("<side>", "right")
        .replace("<type>", settings.scale_edge_type)}
      ${html.bar}
      ${html.caret
        .replace("<type>", settings.scale_caret_type)
        .replace("<position>", caret_pos)
        .replace("<center_position>", settings.scale_caret_offset_center)}
      ${html.content
        .replace("<side>", "left")
        .replace("<text>", settings.texts.scale_small)}
      ${html.content
        .replace("<side>", "")
        .replace("<text>", settings.texts.scale_regular)}
      ${html.content
        .replace("<side>", "right")
        .replace("<text>", settings.texts.scale_large)}
    `;

    if (settings.scale_markers) {
      for (let i = 0; i < settings.scale_markers.length ; i++) {
        let marker_shift = mapTo0To100(settings.scale_markers[i].shift)
        let marker_pos = settings.scale_caret_offset / 2 + (marker_shift / 100) * (100 - settings.scale_caret_offset);
        wrapper.innerHTML += `${html.marker
          .replace('<position>', marker_pos)
          .replace('<shift>', settings.scale_markers[i].shift)
          .replace('<size>', settings.scale_markers[i].size)
          .replace('<show>', settings.scale_markers[i].show ? 'show' : '')}
        `
      }
    }
  } else {
    let html = {
      text_wrapper: '<div class="size_insights--text-wrapper"><text></div>',
    };
    let text = settings.texts[settings.text_scale_breakdown[settings.text_scale_breakdown.length - 1].text]

    for (let i = 0; i < settings.text_scale_breakdown.length ; i++) {
      if (settings.shift <= settings.text_scale_breakdown[i].shift && settings.texts[settings.text_scale_breakdown[i].text]) {
        text = settings.texts[settings.text_scale_breakdown[i].text]
        break
      }
    }

    /*
    -1 | 0 | We recommend smaller size, so person should size up
    0 | 50 | True to size
    1 | 100 | We recommend bigger size, so person should size down
    */

    if (text) {
      wrapper.innerHTML = `
        ${html.text_wrapper.replace("<text>", text)}
      `;
    }
  }

  // Apply custom styling
  var r = document.querySelector(":root");
  function set_root_css_variable(variable, value) {
    wrapper.style.setProperty("--" + variable, value);
  }

  Object.keys(settings.style).forEach((key) => {
    set_root_css_variable(key, settings.style[key]);
  });

  let placeholder = document.querySelector(settings.placeholder);
  if (placeholder) {
    placeholder[settings.placeholder_type](wrapper);
  }
}



// WEBPACK FOOTER //
// ./src/js/components/size-insights.js